import React, { FC } from "react";
import TermoProvider from "./Termo.Provider";

export const withTermoContext = (WrappedComponent: FC<any>) => (props: any) =>
  (
    <TermoProvider>
      <WrappedComponent {...props} />
    </TermoProvider>
  );
